// ✅ Add `ref` support with forwardRef
import { forwardRef, useImperativeHandle, useEffect, useState, useContext } from "react";
import { Image, Button, message, Spin, Flex, Divider, Empty } from "antd";
import { DeleteOutlined, FileImageOutlined } from "@ant-design/icons";
import { LanguageContext } from "../../../utils/lang_provider";

const ImageGalleryWidget = forwardRef(({ type, object }, ref) => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { language } = useContext(LanguageContext);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadImages = async () => {
    if (!object?.id) return;
    setLoading(true);
    try {
      const res = await fetch(`${backendUrl}/front/images/${type}/${object.id}?language=${language.id}`);
      if (!res.ok) throw new Error("Failed to load image list");
      const data = await res.json();
      setImages(data.images || []);
    } catch (err) {
      message.error("Could not load images.");
      setImages([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (filename) => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(`${backendUrl}/admin/content/update/${type}/image/${object.id}/${filename}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });
      if (!res.ok) throw new Error();
      message.success("Image deleted.");
      setImages((prev) => prev.filter((img) => img !== filename));
    } catch {
      message.error("Could not delete image.");
    }
  };

  useImperativeHandle(ref, () => ({
    refetch: loadImages
  }));

  useEffect(() => {
    loadImages();
  }, [type, object, language]);

  if (loading) return <Spin />;

  return (
    <Flex wrap="wrap" gap={16}>
        <Divider orientation="left"><FileImageOutlined></FileImageOutlined> Images</Divider> 
        {images.length > 0 ? images.map((filename) => (
        <div key={filename} style={{ position: "relative", display: "inline-block" }}>
          <Image
            src={`${backendUrl}/front/images/${type}/${object.id}/${filename}?language=${language.id}`}
            width={200}
            style={{ borderRadius: 8 }}
          />
          <Button
            type="primary"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(filename)}
            style={{
              position: "absolute",
              top: 5,
              right: 5,
              padding: "2px 6px",
              fontSize: 12,
            }}
          />
        </div>
      )) : <Empty description="No Images"></Empty>}
    </Flex>
  );
});

export default ImageGalleryWidget;
